import { defineStore } from 'pinia'
import InventoryService from "@/services/inventory.service.js";
export const useInventoryStore = defineStore('inventory', {
    state: () => {
        return {
            inventories: [],
            inventory: null,
            paginate: {},
            lastPage: 1,
        }
    },
    persist: true,
    actions: {
        async getListInventories(url, params) {
            try {
                const res = await InventoryService.getListInventories(url, params)
                this.inventories = res.data.data
                this.paginate = res.data.meta
                this.lastPage = res.data.meta.page
            } catch (e) {
                return null
            }
        },
        async getListInventoriesWithLimit(url, params) {
            try {
                const res = await InventoryService.getListInventories(url, params)
                this.inventories = res.data.data
                this.paginate = res.data.meta
                this.lastPage = res.data.meta.page
            } catch (e) {
                return null
            }
        },
        async getArrivalDetail(url, params) {
            try {
                const res = await InventoryService.getArrivalDetail(url, params)
                this.inventory = res.data
            } catch (e) {
                return null
            }
        },
    }
})
